export const SUBSCRIPTIONS_LIST_SUCCESS = 'SUBSCRIPTIONS_LIST_SUCCESS';
export const SUBSCRIPTIONS_GET_DELAYS_FILTER = 'SUBSCRIPTIONS_GET_DELAYS_FILTER';
export const SUBSCRIPTIONS_GET_DELAYS_FILTER_SUCCESS = 'SUBSCRIPTIONS_GET_DELAYS_FILTER_SUCCESS';
export const SUBSCRIPTIONS_GET_DELAYS_FILTER_ERROR = 'SUBSCRIPTIONS_GET_DELAYS_FILTER_ERROR';
export const SUBSCRIPTIONS_GET_DELAYS_FILTER_CLEAR = 'SUBSCRIPTIONS_GET_DELAYS_FILTER_CLEAR';
export const SUBSCRIPTIONS_GET_SERVICE_FILTER = 'SUBSCRIPTIONS_GET_SERVICE_FILTER';
export const SUBSCRIPTIONS_GET_SERVICE_FILTER_SUCCESS = 'SUBSCRIPTIONS_GET_SERVICE_FILTER_SUCCESS';
export const SUBSCRIPTIONS_GET_SERVICE_FILTER_ERROR = 'SUBSCRIPTIONS_GET_SERVICE_FILTER_ERROR';
export const SUBSCRIPTIONS_CHANGE_SORT = 'SUBSCRIPTIONS_CHANGE_SORT';
export const SUBSCRIPTIONS_CHANGE_STATUS_SUCCESS = 'SUBSCRIPTIONS_CHANGE_STATUS_SUCCESS';
export const SUBSCRIPTIONS_CHANGE_STATUSES_SUCCESS = 'SUBSCRIPTIONS_CHANGE_STATUSES_SUCCESS';
export const SUBSCRIPTIONS_CHANGE_EXPIRY_SUCCESS = 'SUBSCRIPTIONS_CHANGE_EXPIRY_SUCCESS';
export const SUBSCRIPTIONS_RESEND = 'SUBSCRIPTIONS_RESEND';
export const SUBSCRIPTIONS_RESEND_SUCCESS = 'SUBSCRIPTIONS_RESEND_SUCCESS';
export const SUBSCRIPTIONS_RESEND_ERROR = 'SUBSCRIPTIONS_RESEND_ERROR';
export const SUBSCRIPTIONS_LOADING_TABLE = 'SUBSCRIPTIONS_LOADING_TABLE';
export const SUBSCRIPTIONS_UPDATE_SEARCH = 'SUBSCRIPTIONS_UPDATE_SEARCH';
export const SUBSCRIPTIONS_LIST_UPDATE = 'SUBSCRIPTIONS_LIST_UPDATE';
export const SUBSCRIPTIONS_LIST_UPDATE_ERROR = 'SUBSCRIPTIONS_LIST_UPDATE_ERROR';
export const SUBSCRIPTIONS_LIST_UPDATE_SUCCESS = 'SUBSCRIPTIONS_LIST_UPDATE_SUCCESS';
export const SUBSCRIPTIONS_PAGINATION_UPDATE = 'SUBSCRIPTIONS_PAGINATION_UPDATE';
export const SUBSCRIPTIONS_PAGINATION_UPDATE_SUCCESS = 'SUBSCRIPTIONS_PAGINATION_UPDATE_SUCCESS';
export const SUBSCRIPTIONS_PAGINATION_UPDATE_ERROR = 'SUBSCRIPTIONS_PAGINATION_UPDATE_ERROR';
export const SUBSCRIPTIONS_CHECKED_ADD = 'SUBSCRIPTIONS_CHECKED_ADD';
export const SUBSCRIPTIONS_CHECKED_ADD_SHIFT = 'SUBSCRIPTIONS_CHECKED_ADD_SHIFT';
export const SUBSCRIPTIONS_CHECKED_DELETE = 'SUBSCRIPTIONS_CHECKED_DELETE';
export const SUBSCRIPTIONS_CHECKED_DELETE_SHIFT = 'SUBSCRIPTIONS_CHECKED_DELETE_SHIFT';
export const SUBSCRIPTIONS_CHECKED_ADD_ID = 'SUBSCRIPTIONS_CHECKED_ADD_ID';
export const SUBSCRIPTIONS_CHECKED_MASS_ADD = 'SUBSCRIPTIONS_CHECKED_MASS_ADD';
export const SUBSCRIPTIONS_CHECKED_MASS_DELETE = 'SUBSCRIPTIONS_CHECKED_MASS_DELETE';
export const SUBSCRIPTIONS_CHANGE_FILTER_TYPE = 'SUBSCRIPTIONS_CHANGE_FILTER_TYPE';
export const SUBSCRIPTIONS_CHANGE_FILTER_QUERY = 'SUBSCRIPTIONS_CHANGE_FILTER_QUERY';
export const SUBSCRIPTIONS_CHANGE_FILTER_SEARCH_TYPE = 'SUBSCRIPTIONS_CHANGE_FILTER_SEARCH_TYPE';
export const SUBSCRIPTIONS_MODAL_CLOSE = 'SUBSCRIPTIONS_MODAL_CLOSE';
export const SUBSCRIPTIONS_MODAL_OPEN = 'SUBSCRIPTIONS_MODAL_OPEN';
export const SUBSCRIPTIONS_CHANGE_PAGE = 'SUBSCRIPTIONS_CHANGE_PAGE';
export const SUBSCRIPTIONS_CHANGE_FILTER = 'SUBSCRIPTIONS_CHANGE_FILTER';
